<p>articulos-picking works!</p>
